import { ROUTER_PATHS } from '@/constants/router/paths'

/** ヘッダメニュー */
export const HeaderMenu = [
  { displayLabel: 'ユーザー管理', path: ROUTER_PATHS.orgAdminManagement },
  { displayLabel: 'ユーザー管理', path: ROUTER_PATHS.orgMemberManagement },
  { displayLabel: '空撮画像アップローダー(被災家屋)', path: ROUTER_PATHS.uploadAeroPic },
  { displayLabel: '空撮画像アップローダー(固定資産)', path: ROUTER_PATHS.uploadPropertyTax },
] as const
